/* eslint-disable no-underscore-dangle */
import PagingFeed from '../lib/PagingFeed';

class PagingConfigAuditPolicyFeed extends PagingFeed {
  _getFeed() {
    return this._EntityDef.startConfigAuditPoliciesFeed(
      this._activeOrgId,
      this._filter,
      this._entityFields,
      this._sort,
      {skip: 0, limit: 100}
    );
  }

  _getDistinctValuesOfField(tenantId, field) {
    return this._EntityDef.startConfigAuditPolicyDistinctValuesFeed(tenantId, field);
  }

  _getFeedIdsForSelection(tenantId, selection) {
    return this._EntityDef.loadConfigAuditPolicyIdsForSelection(tenantId, selection);
  }

  getConfigAuditPolicyEntitiesById(ids) {
    return this.getEntitiesById(ids);
  }

  getConfigAuditPolicyEntitiesNameById(ids) {
    return this.getEntitiesNameById(ids);
  }

  getConfigAuditPolicyEntityById(id) {
    return this.getEntityById(id);
  }
}

export default PagingConfigAuditPolicyFeed;
